import React, { ReactElement, useEffect, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Popconfirm,
  Row,
  Space,
  Table,
  Typography,
} from 'antd'
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons'
import { IHistorico } from '@app'
import { useFetch, useRouter } from '@customHooks'
import { ContainerTabela } from '@pages/style'
import api from '@services/api'

const { Column } = Table

export default function HistoricosBancarios(): ReactElement {
  const { navigate } = useRouter()
  const [source, setSource] = useState<IHistorico[]>([] as IHistorico[])
  const [reload, setReload] = useState(false)

  const { apiData: historico, isLoading } = useFetch<IHistorico>({
    url: '/historicobancario',
    reload,
  })

  useEffect(() => {
    setSource(historico)
  }, [historico])

  const onDelete = async (id: number) => {
    await api
      .delete(`/historicobancario/${id}`)
      .finally(() => setReload(!reload))
  }

  return (
    <ContainerTabela>
      <Card style={{ marginBottom: '1.5rem' }}>
        <Row align='middle' justify='space-between'>
          <Col>
            <Typography.Title level={4} style={{ margin: 'auto' }}>
              Históricos Bancários
            </Typography.Title>
          </Col>
          <Col>
            <Button
              icon={<PlusOutlined />}
              size='large'
              type='primary'
              onClick={() => navigate('novo')}
            >
              Novo
            </Button>
          </Col>
        </Row>
      </Card>
      <Table
        loading={isLoading}
        dataSource={source}
        rowKey={(record) => record.ID_HISTORICOBANCARIO}
      >
        <Column<IHistorico>
          title='Cód.'
          dataIndex='ID_HISTORICOBANCARIO'
          width='10%'
          // sorter={(a, b) => a.ID_ATIVIDADE - b.ID_ATIVIDADE}
        />
        <Column<IHistorico>
          title='Sinal'
          dataIndex='SINAL'
          render={(sinal) => (sinal === '1' ? 'Entrada' : 'Saída')}
          // sorter={(a, b) => a.DESCATIVIDADE.localeCompare(b.DESCATIVIDADE)}
        />
        <Column<IHistorico>
          title='Concilia Automaticamente?'
          dataIndex='CONCILIA_AUT'
          render={(concilia) => (concilia === '1' ? 'Sim' : 'Não')}
          // sorter={(a, b) => a.DESCATIVIDADE.localeCompare(b.DESCATIVIDADE)}
        />
        <Column<IHistorico>
          title='Descrição'
          dataIndex='DESCHISTORICO'
          // sorter={(a, b) => a.DESCATIVIDADE.localeCompare(b.DESCATIVIDADE)}
        />
        <Column<IHistorico>
          width='10%'
          render={(_, record) => (
            <Space>
              <Button
                onClick={() => navigate(`${record.ID_HISTORICOBANCARIO}`)}
                type='link'
                icon={<EditOutlined />}
              />
              <Popconfirm
                title='Deseja realmente excluir este registro?'
                onConfirm={() => onDelete(record.ID_HISTORICOBANCARIO)}
              >
                <Button type='text' icon={<DeleteOutlined />} />
              </Popconfirm>
            </Space>
          )}
        />
      </Table>
    </ContainerTabela>
  )
}
